import { Component, OnInit, HostListener } from '@angular/core';
import { BaseListComponent } from '../../../../shared/base/base-list.component'
import { RouteAuthorities } from '../../../../shared/base/base.models';
import { BaseService } from '../../../../shared/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../../app.constants';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { DialogService, Dialog } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { UtilityService } from 'src/app/core/utility.service';
import { RequestService, HttpRequestType } from 'src/app/core/request.service';
import { DistributionCalendar } from '../distribution-calendars.models';
import { OptionsSource } from 'src/app/core/core.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { DistributionCalendarsService } from '../distribution-calendars.service';
import { DeliveryZonesService } from '../../delivery-zones/delivery-zones.services';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { DeliveryZone } from '../../delivery-zones/delivery-zones.models';

@Component({
  selector: 'app-distribution-calendars-list',
  templateUrl: './distribution-calendars-list.component.html',
  styleUrls: ['./distribution-calendars-list.component.scss']
})
export class DistributionCalendarsListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'distribution-calendars_list_grid_state';
  public lookupColumns: Array<string> = ['pointOfSale.name', 'meansOfDelivery.description', 'deliveryZone.name', 'date', 'timeFrom', 'timeTo', 'capacity', 'usedCapacity'];

  public isGenerateDistributionCalendarsModalVisible: boolean = false;
  public formPointOfSale;
  public formMeansOfDelivery;
  public formDeliveryZone;
  public formDateFrom;
  public formDateTo;
  public adaptivityEnabled: boolean = false;
  public useCapacitiesUp:boolean = false; 

  currentDate: Date = new Date();
  currentView = {
    type: 'week',
    dateCellTemplate: 'dateCellTemplate'
  };
  minDate = new Date();

  distributionCalendars: DistributionCalendar[] = [];
  public pointsOfSale: OptionsSource;
  public meansOfDelivery: OptionsSource;
  public deliveryZones: OptionsSource;
  public selectedDeliveryZones: DeliveryZone[] = [];

  public activateClicked: boolean = false;
  public deleteClicked: boolean = false;
  public selectedAppointment;
  public showPOSname: boolean = false;

  views: any = ['day', {
    type: 'week',
    dateCellTemplate: 'dateCellTemplate'
  }, {
    type: 'month',
    dateCellTemplate: 'dateCellTemplate'
  }];

  constructor(
    private distributionCalendarsService: DistributionCalendarsService,
    private deliveryZonesService: DeliveryZonesService,
    private pointsOfSaleService: PointsOfSaleService,
    private meansOfDeliveryService: MeansOfDeliveryService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit(): void {
    this.url = `${Constants.contextPath}/distribution-calendars`;
    this.prepareLookupData();
    this.getData();
  }

  private getData() {
    let dateFrom;
    let dateTo;
    
    if(this.currentView.type == 'week') {
      let weekRange = this.utilityService.getWeekRangeFromDate(this.currentDate);
      let dateRange = this.utilityService.getWeekDaysByWeekNumber(weekRange, this.currentDate);
      dateFrom = dateRange[0];
      dateTo = dateRange[6];
    } else if (this.currentView.type == 'day') {
      let day = this.utilityService.formatDateToYYYYMMDD(this.currentDate);
      dateFrom = day;
      dateTo = day;
    } 
    else { // month
      let days = this.utilityService.getFirstAndLastDayOfMonthFromDay(this.currentDate);
      dateFrom = days.dateFrom;
      dateTo = days.dateTo;
    }

    this.distributionCalendarsService.getCaledarData(dateFrom, dateTo, (response: DistributionCalendar[])=> {
      for (let c of response)
        c = this.modifyResponse(c);

      this.distributionCalendars = response;
      this.showPOSname = this.distributionCalendars.some(dc => (<PointOfSale>dc.pointOfSale).id != (<PointOfSale>this.distributionCalendars[0].pointOfSale).id );
    })    
  }

  private modifyResponse(c) {
    let hoursFrom = this.utilityService.getHoursFromTimeString(c.timeFrom);
    let minutesFrom = this.utilityService.getMinutesFromTimeString(c.timeFrom);

    let hoursTo = this.utilityService.getHoursFromTimeString(c.timeTo);
    let minutesTo = this.utilityService.getMinutesFromTimeString(c.timeTo);

    c.startDate = new Date(c.date);
    c.startDate.setHours(hoursFrom);
    c.startDate.setMinutes(minutesFrom);

    c.endDate = new Date(c.date);
    c.endDate.setHours(hoursTo);
    c.endDate.setMinutes(minutesTo);
    return c;
  }

  private prepareLookupData() {
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.meansOfDelivery = this.meansOfDeliveryService.getMeansOfDeliveryOptions();
    this.deliveryZones = this.deliveryZonesService.getDeliveryZonesOptions();
  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }

  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  onOptionChanged(e) {
    if (e.fullName == "currentDate") {
    console.log("ON OPTION CHANGE", e.value)
      this.currentDate = e.value;
      this.getData();
    }
    else if (e.fullName == "currentView") {
      this.currentView = e.value;
      this.getData();
    }
  }

  public openGenerateDistributionCalendarsModal() {
    this.isGenerateDistributionCalendarsModalVisible = true;
  }

  public closeGenerateDistributionCalendarsModal() {
    this.clearValues();
    this.isGenerateDistributionCalendarsModalVisible = false;
  }

  clearValues() {
    this.formPointOfSale = null;
    this.formMeansOfDelivery = null;
    this.formDeliveryZone = null;
    this.formDateFrom = null;
    this.formDateTo = null;
    this.useCapacitiesUp = false;
  }

  public generateDistributionCalendars() {
    if(this.formPointOfSale == null || this.formMeansOfDelivery == null || this.selectedDeliveryZones == null || this.formDateFrom == null || this.formDateTo == null) {
      this.alertService.error('DISTRIBUTION_CALENDARS.GENERATION_FORM_ERROR');
      return;
    }

    if(this.formDateFrom < new Date() || this.formDateFrom > this.formDateTo) {
      this.alertService.error('DISTRIBUTION_CALENDARS.DATE_ERROR');
      return;
    }

    let data = {
      pointOfSale: this.formPointOfSale,
      meansOfDelivery: this.formMeansOfDelivery,
      deliveryZones: this.selectedDeliveryZones,
      dateFrom: this.formDateFrom,
      dateTo: this.formDateTo,
      useCapacitiesUp: this.useCapacitiesUp
    };

    this.distributionCalendarsService.generateDistributionCalendar(data, (response) => {
      this.getData();
      this.alertService.success('DISTRIBUTION_CALENDARS.CALENDARS_GENERATED_SUCCESSFULLY');
      this.closeGenerateDistributionCalendarsModal();
    })
  }

  private modifyDataBeforeUpdate(data) {
    if (data.pointOfSale && data.pointOfSale.id) {
      data.pointOfSale = data.pointOfSale.id;
    }

    if (data.meansOfDelivery && data.meansOfDelivery.id) {
      data.meansOfDelivery = data.meansOfDelivery.id;
    }

    if (data.deliveryZone && data.deliveryZone.id) {
      data.deliveryZone = data.deliveryZone.id;
    }

    return data;
  }

  private checkTimes(data) {
    data.timeFrom = this.checkRegex(data.timeFrom);
    data.timeTo = this.checkRegex(data.timeTo);
    return data;
  }

  private checkRegex(time) {
    if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time) == false) {
      return this.utilityService.formatDateTimeToTime(time);
    }
    return time;
  }

  onAppointmentAdded(e) {
    this.baseService.create(this.url, this.modifyDataBeforeUpdate(this.checkTimes(e.appointmentData)), (response) => {
      this.getData();
      this.alertService.success("SHARED.SAVE_SUCCESS");
    }, (error) => {
      this.getData();
      this.alertService.error(error, true);
    });
  }

  onAppointmentUpdated(e) {
    this.baseService.update(this.url, this.modifyDataBeforeUpdate(e.appointmentData), (response) => {
      this.getData();
      this.alertService.success("SHARED.SAVE_SUCCESS");
    }, (error) => {
      this.getData();
      this.alertService.error(error, true);
    });
  }

  public delete(appointment: string): void {
    this.selectedAppointment = appointment;
    this.deleteClicked = true
  }

  public activate(appointment: string): void {
    this.selectedAppointment = appointment;
    this.activateClicked = true
  }

  onAppointmentDeleted(e) {
    this.baseService.delete(this.url, e.appointmentData.id, () => {
      this.getData();
      // let index = this.distributionCalendars.findIndex(dc => dc.id == e.appointmentData.id);
      // if(index > -1) {
      //   this.distributionCalendars.splice(index, 1);
      // }
      this.alertService.success("SHARED.DELETE_SUCCESS");
    })
  }

  onAppointmentFormOpening(data) {
    if (this.deleteClicked) {
      data.cancel = true;
      let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
        this.baseService.delete(this.url, this.selectedAppointment.id, () => {
          this.getData();
          this.alertService.success('SHARED.DELETE_SUCCESS');
          this.selectedAppointment = null;
          this.deleteClicked = false;
        }, (error) => {
          this.alertService.error(error, true);
        });
      }, (reject) => {
        this.selectedAppointment = null;
        this.deleteClicked = false;
      });

      this.dialogService.show(dialog);
    } else if (this.activateClicked) {
      data.cancel = true;
      let dialog = new Dialog(this.selectedAppointment.active ? 'SHARED.DEACTIVATE_QUESTION' : 'SHARED.ACTIVATE_QUESTION', () => {
        this.baseService.delete(this.url, this.selectedAppointment.id, () => {
          this.getData();
          this.alertService.success(this.selectedAppointment.active ? 'SHARED.ACTIVATE_SUCCESS' : 'SHARED.DEACTIVATE_SUCCESS');
          this.selectedAppointment = null;
          this.activateClicked = false;
        }, (error) => {
          this.alertService.error(error, true);
        });
      }, (reject) => {
        this.selectedAppointment = null;
        this.activateClicked = false;
      });

      this.dialogService.show(dialog);
    } else {
      let that = this;
      let form = data.form;
      let appointmentData = data.appointmentData;
      let startDate = appointmentData.startDate;
      let endDate = appointmentData.endDate;

      form.option("items", [{
        label: {
          text: this.translateService.instant('POINTS_OF_SALE.POINT_OF_SALE')
        },
        editorType: "dxSelectBox",
        dataField: "pointOfSale",
        editorOptions: {
          dataSource: that.pointsOfSale,
          displayExpr: "name",
          valueExpr: "id",
          readOnly: true
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('POINTS_OF_SALE.REQUIRED')
        }]
      },
      {
        label: {
          text: this.translateService.instant('MEANS_OF_DELIVERY.MEAN_OF_DELIVERY')
        },
        editorType: "dxSelectBox",
        dataField: "meansOfDelivery",
        editorOptions: {
          dataSource: that.meansOfDelivery,
          displayExpr: "description",
          valueExpr: "id",
          readOnly: true
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('MEANS_OF_DELIVERY.REQUIRED')
        }]
      },
      {
        label: {
          text: this.translateService.instant('SHARED.DELIVERY_ZONE')
        },
        editorType: "dxSelectBox",
        dataField: "deliveryZone",
        editorOptions: {
          dataSource: that.deliveryZones,
          displayExpr: "name",
          valueExpr: "id",
          readOnly: true
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('DELIVERY_ZONES.REQUIRED')
        }]
      }, {
        label: {
          text: this.translateService.instant('SHARED.DATE')
        },
        dataField: "date",
        editorType: "dxDateBox",
        editorOptions: {
          width: "100%",
          type: "date",
          displayFormat: 'dd.MM.yyyy',
          pickerType: 'calendar',
          readOnly: true,
          dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
          value: appointmentData.id ? appointmentData.date : startDate
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('SHARED.DATE_REQUIRED')
        }]
      }, {
        label: {
          text: this.translateService.instant('SHARED.TIME_FROM')
        },
        dataField: "timeFrom",
        editorType: "dxDateBox",
        editorOptions: {
          width: "100%",
          type: 'time',
          displayFormat: 'HH:mm',
          pickerType: 'time',
          readOnly: true,
          dateSerializationFormat: 'HH:mm',
          value: appointmentData.id ? appointmentData.timeFrom : startDate
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('SHARED.TIME_FROM_REQUIRED')
        }]
      }, {
        label: {
          text: this.translateService.instant('SHARED.TIME_TO')
        },
        dataField: "timeTo",
        editorType: "dxDateBox",
        editorOptions: {
          width: "100%",
          type: 'time',
          displayFormat: 'HH:mm',
          pickerType: 'time',
          readOnly: true,
          dateSerializationFormat: 'HH:mm',
          value: appointmentData.id ? appointmentData.timeTo : endDate
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('SHARED.TIME_TO_REQUIRED')
        }]
      }, {
        label: {
          text: this.translateService.instant('DISTRIBUTION_CALENDARS.CAPACITY')
        },
        dataField: "capacity",
        editorType: "dxNumberBox",
        editorOptions: {
          showSpinButtons: true,
          min: 0
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('DISTRIBUTION_CALENDARS.CAPACITY_REQUIRED')
        }]
      }, {
        label: {
          text: this.translateService.instant('DISTRIBUTION_CALENDARS.USED_CAPACITY')
        },
        dataField: "usedCapacity",
        editorType: "dxNumberBox",
        editorOptions: {
          showSpinButtons: true,
          min: 0
        },
        validationRules: [{
          type: "required",
          message: this.translateService.instant('DISTRIBUTION_CALENDARS.USED_CAPACITY_REQUIRED')
        }]
      }]);
    }
  }

  public setBackgroundColor(capacity: number, usedCapacity: number) {
    let percentage = (usedCapacity / capacity) * 100;
    if(percentage <= 10)
      return 'green'
    if(percentage > 10 && percentage <= 30)
      return 'blue';
    else if(percentage > 30 && percentage <= 90)
      return 'yellow';
    else
      return 'red';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adaptivityEnabled = window.innerWidth < 1600;
  }
}
